import renderAuthorize, { CURRENT } from './renderAuthorize';

export { CURRENT };
export default renderAuthorize;
